var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "whatsapp-chat-starter" }, [
    _c("div", [
      _c("label", { attrs: { for: "phoneNumber" } }, [
        _vm._v("Telefon Numarası"),
      ]),
      _vm._v(" "),
      _c("small", [
        _vm._v("Ülke kodu ile birlikte boşluk girmeden sadece rakamlar ile"),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.phoneNumber,
            expression: "phoneNumber",
          },
        ],
        attrs: { type: "text" },
        domProps: { value: _vm.phoneNumber },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.phoneNumber = $event.target.value
          },
        },
      }),
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("label", { attrs: { for: "channelId" } }, [_vm._v("Kanal")]),
        _vm._v(" "),
        _c("small", [
          _vm._v("Hangi kanal üzerinden chat başlatmak istiyorsun"),
        ]),
        _vm._v(" "),
        _c("ChannelPicker", {
          attrs: {
            "allowed-types": [
              "whatsapp-qr",
              "whatsapp-v2",
              "whatsapp-business-api",
            ],
            autoSelectFirst: false,
          },
          model: {
            value: _vm.channelId,
            callback: function ($$v) {
              _vm.channelId = $$v
            },
            expression: "channelId",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "footer",
      [
        _c(
          "SupsisButton",
          { attrs: { primary: "" }, on: { click: _vm.startChat } },
          [_vm._v(" Chat Başlat")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }